import React, { useEffect, useState } from 'react';
import { addMonths } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function TimePickerHandler({ form_data, setFormData, Name = "input", Label = "", is_disabled = false }) {
    const [selectedTime, setSelectedTime] = useState(form_data[Name] ? new Date(`1970-01-01T${form_data[Name]}`) : new Date());

    useEffect(() => {
        // Update internal selectedTime when form_data[Name] changes
        if (form_data[Name]) {
            setSelectedTime(new Date(`1970-01-01T${form_data[Name]}`));
        }
    }, [form_data, Name]);

    const handleChange = (time) => {
        setSelectedTime(time);
        const formattedTime = time.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        setFormData(prev => ({
            ...prev,
            [Name]: formattedTime
        }));
    };

    return (
        <div className='form-group CustomDatepicker'>
            {Label && <label className="form-label">{Label}</label>}
            <DatePicker
                selected={selectedTime}
                onChange={(time) => handleChange(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15} // ✅ time gap of 15 minutes
                timeCaption="Time"
                dateFormat="h:mm aa" // 24-hour format
                disabled={is_disabled}
                minTime={new Date().setHours(0, 0, 0, 0)}
                maxTime={new Date().setHours(23, 45, 0, 0)}
                className="form-control w-100px"
                placeholderText={`Select ${Label}`}
                isClearable
                icon={
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 48 48"
                    >
                        <mask id="ipSApplication0">
                            <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                    fill="#fff"
                                    d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                            </g>
                        </mask>
                        <path
                            fill="currentColor"
                            d="M0 0h48v48H0z"
                            mask="url(#ipSApplication0)"
                        ></path>
                    </svg>
                }
            />
        </div>
    );
}
